export default __webpack_public_path__ + "static/media/Kiwi.101fa1a3.png";